(function () {
  'use strict';

  var config = window.DevidAssistantLoaderConfig || {};
  var root = document.querySelector('[data-devid-assistant-v2]');
  if (!root) return;

  var launcher = root.querySelector('[data-assistant-launcher]');
  var dismissButton = root.querySelector('[data-assistant-launcher-dismiss]');
  var restoreButton = root.querySelector('[data-assistant-launcher-restore]');
  var storageKey = 'devid_assistant_launcher_minimized';
  var loadingPromise = null;
  var loaded = false;
  var proxy = null;

  function readMinimizedState() {
    try {
      return window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function writeMinimizedState(isMinimized) {
    try {
      if (isMinimized) window.sessionStorage.setItem(storageKey, '1');
      else window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  function setMinimized(isMinimized, shouldFocus) {
    root.classList.toggle('is-launcher-dismissed', isMinimized);
    if (restoreButton) restoreButton.hidden = !isMinimized;
    writeMinimizedState(isMinimized);

    if (shouldFocus) {
      var target = isMinimized ? restoreButton : launcher;
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }
  }

  function loadStyle(url) {
    return new Promise(function (resolve, reject) {
      if (!url) {
        resolve();
        return;
      }

      var existing = document.querySelector('link[data-devid-assistant-style="' + url + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true' || existing.sheet) resolve();
        else {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.setAttribute('data-devid-assistant-style', url);
      link.addEventListener('load', function () {
        link.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      link.addEventListener('error', reject, { once: true });
      document.head.appendChild(link);
    });
  }

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      if (!url) {
        resolve();
        return;
      }

      var existing = document.querySelector('script[data-devid-assistant-script="' + url + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') resolve();
        else {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      var script = document.createElement('script');
      script.src = url;
      script.async = false;
      script.setAttribute('data-devid-assistant-script', url);
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.body.appendChild(script);
    });
  }

  function removeBootstrapListeners() {
    if (launcher) {
      launcher.removeEventListener('click', handleLauncherClick);
      launcher.removeEventListener('mouseenter', warmAssistant);
      launcher.removeEventListener('focus', warmAssistant);
      launcher.removeEventListener('touchstart', warmAssistant);
    }
    if (dismissButton) dismissButton.removeEventListener('click', handleDismiss);
    if (restoreButton) restoreButton.removeEventListener('click', handleRestore);
  }

  function loadScriptsInOrder() {
    return (config.scripts || []).reduce(function (chain, url) {
      return chain.then(function () { return loadScript(url); });
    }, Promise.resolve());
  }

  function ensureLoaded() {
    if (loaded) return Promise.resolve();
    if (loadingPromise) return loadingPromise;

    root.classList.add('is-loading');
    if (launcher) launcher.setAttribute('aria-busy', 'true');

    loadingPromise = Promise.all((config.styles || []).map(loadStyle))
      .then(loadScriptsInOrder)
      .then(function () {
        loaded = true;
        root.classList.remove('is-loading');
        root.setAttribute('data-assistant-loaded', 'true');
        if (launcher) launcher.removeAttribute('aria-busy');
        removeBootstrapListeners();
      }).catch(function (error) {
        loadingPromise = null;
        root.classList.remove('is-loading');
        root.classList.add('has-load-error');
        if (launcher) launcher.removeAttribute('aria-busy');
        throw error;
      });

    return loadingPromise;
  }

  function currentApi() {
    var api = window.DevidAssistantV2;
    return api && api !== proxy ? api : null;
  }

  function openAssistant() {
    return ensureLoaded().then(function () {
      var api = currentApi();
      if (api && typeof api.open === 'function') api.open();
    });
  }

  function sendToAssistant(message) {
    return ensureLoaded().then(function () {
      var api = currentApi();
      if (api && typeof api.send === 'function') api.send(message);
    });
  }

  function warmAssistant() {
    ensureLoaded().catch(function () {});
  }

  function handleLauncherClick(event) {
    event.preventDefault();
    openAssistant().catch(function () {});
  }

  function handleDismiss(event) {
    event.preventDefault();
    event.stopPropagation();
    setMinimized(true, true);
  }

  function handleRestore(event) {
    event.preventDefault();
    setMinimized(false, true);
  }

  setMinimized(readMinimizedState(), false);

  if (launcher) {
    launcher.addEventListener('click', handleLauncherClick);
    launcher.addEventListener('mouseenter', warmAssistant, { once: true, passive: true });
    launcher.addEventListener('focus', warmAssistant, { once: true, passive: true });
    launcher.addEventListener('touchstart', warmAssistant, { once: true, passive: true });
  }
  if (dismissButton) dismissButton.addEventListener('click', handleDismiss);
  if (restoreButton) restoreButton.addEventListener('click', handleRestore);

  proxy = {
    open: openAssistant,
    close: function () {
      return ensureLoaded().then(function () {
        var api = currentApi();
        if (api && typeof api.close === 'function') api.close();
      });
    },
    reset: function () {
      return ensureLoaded().then(function () {
        var api = currentApi();
        if (api && typeof api.reset === 'function') api.reset();
      });
    },
    send: sendToAssistant,
    load: ensureLoaded
  };

  window.DevidAssistantV2 = proxy;
})();
